const TUNNEL_HOST_PATTERNS = ['.loca.lt', '.localtunnel.me'];

const shouldBypassTunnelReminder = (input) => {
  try {
    const rawUrl =
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.toString()
          : input?.url;

    if (!rawUrl) return false;

    const parsedUrl = new URL(rawUrl, window.location.origin);
    return TUNNEL_HOST_PATTERNS.some((suffix) =>
      parsedUrl.hostname.toLowerCase().endsWith(suffix)
    );
  } catch {
    return false;
  }
};

const withTunnelHeaders = (input, init = {}) => {
  if (!shouldBypassTunnelReminder(input)) {
    return init;
  }

  const headers = new Headers(
    init.headers || (input instanceof Request ? input.headers : undefined)
  );

  if (!headers.has('bypass-tunnel-reminder')) {
    headers.set('bypass-tunnel-reminder', 'true');
  }

  return {
    ...init,
    headers,
  };
};

export const installTunnelFetchBypass = () => {
  if (typeof window === 'undefined' || window.__tunnelFetchBypassInstalled) {
    return;
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => originalFetch(input, withTunnelHeaders(input, init));
  window.__tunnelFetchBypassInstalled = true;
};
